import type { CSSProperties } from 'react'

type Orientation = 'horizontal' | 'vertical'

interface DividerProps {
  orientation?: Orientation
  spacing?: number
  className?: string
  style?: CSSProperties
}

export function Divider({
  orientation = 'horizontal',
  spacing = 14,
  className,
  style,
}: DividerProps) {
  const isHorizontal = orientation === 'horizontal'
  return (
    <hr
      role="separator"
      aria-orientation={orientation}
      className={className}
      style={{
        border: 0,
        margin: isHorizontal ? `${spacing}px 0` : `0 ${spacing}px`,
        background: 'var(--border)',
        height: isHorizontal ? 1 : '100%',
        width: isHorizontal ? '100%' : 1,
        alignSelf: 'stretch',
        ...style,
      }}
    />
  )
}
